import { createContext, useContext } from "react";
import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const InstantContext = createContext(false);

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => {
  const instant = useContext(InstantContext);
  return (
    <motion.div
      initial={instant ? false : { opacity: 0, y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: instant ? 0 : delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const instant = useContext(InstantContext);
  return (
    <span className={`-mb-[0.14em] block overflow-hidden pb-[0.14em] ${className}`}>
      <motion.span
        className="block"
        initial={instant ? false : { y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.1, delay: instant ? 0 : delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const Micro = ({ children, tone = "navy", className = "" }) => (
  <span
    className={`font-mono text-[10px] font-medium uppercase tracking-[0.32em] sm:text-[11px] ${
      tone === "navy" ? "text-[#D4AF37]" : "text-[#997A15]"
    } ${className}`}
  >
    {children}
  </span>
);

export const GoldRule = ({ tone = "navy", className = "", delay = 0.4 }) => {
  const instant = useContext(InstantContext);
  return (
    <motion.span
      initial={instant ? false : { scaleX: 0 }}
      animate={{ scaleX: 1 }}
      transition={{ duration: 1.2, delay: instant ? 0 : delay, ease: EASE }}
      className={`block h-px w-16 origin-left ${tone === "navy" ? "bg-[#D4AF37]" : "bg-[#B8860B]"} ${className}`}
    />
  );
};

export const Claim = ({ children, tone = "navy", className = "" }) => (
  <span
    className={`font-sans text-xs font-semibold uppercase tracking-[0.28em] sm:text-sm ${
      tone === "navy" ? "text-[#F3E5AB]" : "text-[#997A15]"
    } ${className}`}
  >
    {children}
  </span>
);

export const WaveMark = ({ size = 26, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M2 15c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2"
      stroke="#D4AF37"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M2 10c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2"
      stroke="#D4AF37"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.45"
    />
  </svg>
);

export const SlideShell = ({ theme, testid, children, className = "", ...rest }) => (
  <div
    data-testid={testid}
    data-slide
    className={`relative h-screen w-screen overflow-hidden ${
      theme === "navy" ? "bg-[#060B19] text-[#FAF7F2]" : "bg-[#FAF7F2] text-[#0B152C]"
    } ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const SlideBody = ({ children, className = "" }) => (
  <div data-slide-scroll="true" className="slide-scroll relative z-10 h-full overflow-y-auto">
    <div
      className={`mx-auto flex min-h-full w-full max-w-[1440px] flex-col justify-center px-6 pb-32 pt-28 sm:px-12 lg:px-20 ${className}`}
    >
      {children}
    </div>
  </div>
);
